// @flow

// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'

// Types
import type {
  Asset,
  AssetsById,
} from 'fc-model-assets/types'

// Constants
import {
  PROP_CATEGORY,
  FARM,
  FIELD,
  PROP_SEASON,
} from 'fc-model-assets'

// Selectors
import { assets$ } from 'fc-assets'
import { selectedSeasonId$ } from 'hfty-seasons'
import category$ from './category'

export default createSelector(
  [assets$, category$, selectedSeasonId$],
  (assets: AssetsById, category: ?string, currSeason: number): Array<Asset> =>
    _filter(assets, (asset: Asset): boolean => {
      if (category) {
        return asset[PROP_CATEGORY] === category && (category === FIELD
          ? asset[PROP_SEASON] === currSeason
          : true)
      }

      return asset[PROP_CATEGORY] === FIELD
        ? asset[PROP_SEASON] === currSeason
        : asset[PROP_CATEGORY] === FARM
    })
)

export const assetsOfCurrentSeason$ = createSelector(
  [assets$, selectedSeasonId$],
  (assets: AssetsById, currSeason: number): Array<Asset> => _filter(assets, (asset: Asset): boolean =>
    asset[PROP_CATEGORY] === FIELD ? asset[PROP_SEASON] === currSeason : asset[PROP_CATEGORY] === FARM
  )
)
